<template>
  <div class="emd-card-grid__row">
    <Bank
      :title="$t('charge.detail.payment-method.bank-transfer.bank')"
      :bank="lastTransaction.bank"
    />

    <TId
      :title="$t('charge.detail.payment-method.bank-transfer.tid')"
      :t-id="lastTransaction.bank_tid"
    />

    <DetailAt
      :updated-at="updatedAt"
      :created-at="createdAt"
    />

    <DueAt
      v-if="dueAt"
      :title="$t('charge.detail.payment-method.bank-transfer.due-at')"
      :dueAt="due"
    />
  </div>
</template>

<script>
export default {
  name: 'ChargesPaymentMethodsBankTransfer',

  components: {
    Bank: () =>
      import(/* webpackChunkName: "bank" */ '../../components/Bank.vue'),
    DueAt: () =>
      import(/* webpackChunkName: "due-at" */ '../../components/DueAt.vue'),
    DetailAt: () =>
      import(
        /* webpackChunkName: "detail-at" */ '../../components/DetailAt.vue'
      ),
    TId: () => import(/* webpackChunkName: "tid" */ '../../components/TId.vue')
  },

  props: {
    lastTransaction: {
      required: true
    },
    dueAt: {
      required: true
    }
  },

  computed: {
    updatedAt () {
      return {
        title: this.$t('charge.detail.payment-method.bank-transfer.updated-at'),
        date: this.lastTransaction.updated_at
      }
    },

    createdAt () {
      return {
        title: this.$t('charge.detail.payment-method.bank-transfer.created-at'),
        date: this.lastTransaction.created_at
      }
    }
  }
}
</script>
